import { createAuditLogger, type AuditContext } from 'app/shared-components/util/auditLog';

export type CreditAuditEvent =
  | 'payment.initiated'
  | 'payment.succeeded'
  | 'payment.failed'
  | 'recurring.configured'
  | 'recurring.cancel_requested'
  | 'recurring.cancelled'
  | 'recurring.cancel_failed'
  | 'bank_account.linked'
  | 'bank_account.linked_pending'
  | 'highnote.snapshot';

export type CreditAuditContext = AuditContext;

export const logCreditAuditEvent = createAuditLogger<CreditAuditEvent>('credit_management');
